import { Component, type ReactNode } from 'react'

import { errorReporter } from '../lib/errorReporter'

/**
 * Keeps an optional part of a page from taking the page down: when its children fail to render,
 * the fallback (by default nothing) shows instead, and React reports the error to the console. A
 * new `key` tries again.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode | ((reference?: string) => ReactNode) }, { failed: boolean; reference?: string }> {
  state: { failed: boolean; reference?: string } = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error: Error) {
    this.setState({ reference: errorReporter.report(error, { operation: 'react' }) })
  }

  render() {
    return this.state.failed
      ? (typeof this.props.fallback === 'function' ? this.props.fallback(this.state.reference) : this.props.fallback ?? null)
      : this.props.children
  }
}
